<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
          :id="id"
          ref="btn"
          v-test="{ btn: id }"
          :icon="!!icon"
          :color="btnColor"
          :small="small"
          :x-large="xLarge"
          :disabled="disabled"
          :class="bClass"
          v-on="on"
          @click.stop="click">
        <v-icon
            v-if="icon"
            :color="iconColor">
          {{ icon }}
        </v-icon>
        {{ icon? '': tip }}
      </v-btn>
    </template>
    <span>
      {{ tip }}
    </span>
  </v-tooltip>
</template>

<script>
  export default {
    props: {
      tip: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      iconColor: {
        type: String,
        default: 'primaryiconbtn'
      },
      bClass: {
        type: String,
        default: null
      },
      btnColor: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      small: {
        type: Boolean,
        default: false
      },
      xLarge: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      vTest: {
        type: Object
      }
    },
    methods: {
      click: function () {
        this.$emit('click')
      }
    }
  }
</script>
